import React, { useState } from 'react';
import css from './FAQSection.module.css';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const ExpandMoreIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const EmailOutlinedIcon = ({ style }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
    aria-hidden="true"
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <path d="M22 6l-10 7L2 6" />
  </svg>
);

const faqData = [
    {
        category: <FormattedMessage id="FAQSection.category.buyAndSell" defaultMessage="KÖPA & SÄLJA" />,
        items: [
            {
                question: <FormattedMessage id="FAQSection.q.buyWheels" defaultMessage="Hur fungerar det att köpa hjul på Wheelplace?" />,
                answer: <FormattedMessage id="FAQSection.a.buyWheels" defaultMessage="Wheelplace är en marknadsplats för hjul..." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.publishAd" defaultMessage="Hur lägger jag upp en annons?" />,
                answer: <FormattedMessage id="FAQSection.a.publishAd" defaultMessage="Privatpersoner betalar 69kr per annons..." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.whatIsRequest" defaultMessage="Vad är en förfrågan?" />,
                answer: <FormattedMessage id="FAQSection.a.whatIsRequest" defaultMessage="Du kan skapa en förfrågan..." />
            }
        ]
    },
    {
        category: <FormattedMessage id="FAQSection.category.tiresAndRims" defaultMessage="DÄCK & FÄLGAR" />,
        items: [
            {
                question: <FormattedMessage id="FAQSection.q.whatFitsMyCar" defaultMessage="Hur vet jag vad som passar min bil?" />,
                answer: <FormattedMessage id="FAQSection.a.whatFitsMyCar" defaultMessage="För att hitta rätt däck till din bil behöver du veta din bils specifikationer, inklusive däckstorlek, belastningsindex och hastighetsklass. Däckstorleken kan hittas på sidan av dina nuvarande däck och ser vanligtvis ut så här: 205/55 R16. 205 anger däckets bredd i millimeter, 55 är däckets profilhöjd som en procentandel av bredden, R står för radial och 16 är fälgens diameter i tum. Använd gärna vår däckväljare där du enkelt kan söka med din bils märke och modell för att hitta kompatibla däck." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.tireLifespan" defaultMessage="Hur länge håller däck?" />,
                answer: <FormattedMessage id="FAQSection.a.tireLifespan" defaultMessage="Däckens livslängd beror på flera faktorer, inklusive körförhållanden, underhåll och kvalitet. Generellt sett kan däck hålla mellan 40 000 och 80 000 kilometer, eller 5–6 år, beroende på användning. Det är viktigt att regelbundet kontrollera mönsterdjupet och leta efter sprickor eller andra tecken på slitage. Vi rekommenderar att byta däck när mönsterdjupet når 3 mm för sommar- och 4 mm för vinterdäck för att bibehålla säkerheten." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.howOftenChangeTires" defaultMessage="Hur ofta behöver jag byta däck?" />,
                answer: <FormattedMessage id="FAQSection.a.howOftenChangeTires" defaultMessage="Däck bör bytas ut när de visar tecken på betydande slitage, som låg mönsterdjup (under 1,6 mm enligt lag, men gärna vid 3–4 mm för säkerhetens skull) eller sprickor. Dessutom rekommenderas byte av däck varje 5–6 år, även om de inte är slitna, på grund av gummits åldrande. Om du kör i tuffa förhållanden, som hårda vintrar eller på ojämna vägar, kan du behöva byta däck oftare." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.whatDoNumbersMean" defaultMessage="Vad betyder siffrorna på däcken?" />,
                answer: <FormattedMessage id="FAQSection.a.whatDoNumbersMean" defaultMessage="Siffrorna på däcksidan ger viktig information om däcket. Till exempel: 205/55 R16 91V betyder att däcket är 205 mm brett, har en profilhöjd som är 55 % av bredden, är av radialkonstruktion, och passar en 16-tums fälg. 91V representerar belastningsindex (hur mycket vikt däcket kan bära) och hastighetsklass (maxhastighet däcket är designat för). Denna information är avgörande när du väljer rätt däck för din bil." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.bestWinterSummerTires" defaultMessage="Vilka är de bästa vinterdäcken/sommardäcken?" />,
                answer: <FormattedMessage id="FAQSection.a.bestWinterSummerTires" defaultMessage="De bästa däcken varierar beroende på dina körbehov och förhållanden. Vinterdäck bör erbjuda bra grepp på is och snö, medan sommardäck bör prestera bra på torra och våta vägar. Populära vinterdäck inkluderar Nokian Hakkapeliitta och Continental VikingContact, medan toppresterande sommardäck inkluderar Michelin Pilot Sport och Goodyear Eagle F1. Läs våra detaljerade däckrecensioner för att hitta det bästa däcket för din bil och körförhållanden." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.measureTreadDepth" defaultMessage="Hur mäter jag mönsterdjupet på mina däck?" />,
                answer: <FormattedMessage id="FAQSection.a.measureTreadDepth" defaultMessage="Mönsterdjupet kan mätas med en enkel mönsterdjupsmätare. Placera mätaren i däckets huvudspår och läs av djupet. För sommardäck bör mönsterdjupet vara minst 3 mm för optimal prestanda, och för vinterdäck rekommenderas minst 4 mm. Under 1,6 mm är olagligt och farligt att köra på, så se till att byta däcken innan du når detta gränsvärde." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.premiumVsBudget" defaultMessage="Vad är skillnaden mellan premium- och budgetdäck?" />,
                answer: <FormattedMessage id="FAQSection.a.premiumVsBudget" defaultMessage="Premiumdäck är tillverkade av högkvalitativa material och erbjuder ofta bättre prestanda, hållbarhet och säkerhet, särskilt under extrema körförhållanden. Budgetdäck är billigare och kan vara ett bra val för förare med lägre årlig körsträcka eller de som kör under mindre krävande förhållanden. Tänk på att premiumdäck ofta ger bättre bränsleeffektivitet och kortare bromssträcka, vilket kan spara pengar och förbättra säkerheten på lång sikt." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.tirePressurePerformance" defaultMessage="Hur påverkar däcktryck min bils prestanda?" />,
                answer: <FormattedMessage id="FAQSection.a.tirePressurePerformance" defaultMessage="Rätt däcktryck är avgörande för att bibehålla optimal bränsleeffektivitet, däcklivslängd och säkerhet. Undertryckta däck kan öka bränsleförbrukningen och leda till snabbare däckslitage, medan övertryckta däck kan minska greppet och orsaka ojämnt slitage. Kontrollera ditt däcktryck minst en gång i månaden och justera enligt tillverkarens rekommendationer, som ofta finns på en etikett inne i dörren på förarsidan." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.repairPuncturedTire" defaultMessage="Kan jag reparera ett punkterat däck?" />,
                answer: <FormattedMessage id="FAQSection.a.repairPuncturedTire" defaultMessage="Det är möjligt att reparera ett punkterat däck om skadan är mindre och begränsad till slitbanan. Dock, om punkteringen är på däckets sidovägg eller om skadan är för stor, rekommenderas det att byta ut däcket för säkerhets skull. Ett reparerat däck kan fortfarande erbjuda säker prestanda om det repareras korrekt av en fackman. Se till att låta en däckverkstad bedöma om reparationen är säker." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.summerWinterAllround" defaultMessage="Vad är skillnaden mellan sommardäck, vinterdäck och allrounddäck?" />,
                answer: <FormattedMessage id="FAQSection.a.summerWinterAllround" defaultMessage="Sommardäck är optimerade för varma väderförhållanden och erbjuder bra grepp på torra och våta vägar. Vinterdäck har en speciell gummiblandning och mönster som ger bättre grepp på snö, is och kalla vägar. Allrounddäck kombinerar egenskaper från både sommar- och vinterdäck, vilket gör dem lämpliga för mildare klimat där extrema vinterförhållanden är ovanliga. Det är dock viktigt att förstå att allrounddäck inte är lika bra som specialiserade däck för specifika säsonger." />
            },
            {
                question: <FormattedMessage id="FAQSection.q.adCost" defaultMessage="Vad kostar en annons?" />,
                answer: <FormattedMessage id="FAQSection.a.adCost" defaultMessage="Privatpersoner betalar 69kr per annons och företag en månadsavgift enligt överenskommet avtal. Detta gör vi för att skapa bästa möjliga värde för alla användare av marknadsplatsen samt säkerställa en användarvänlig, trygg och pålitlig plattform." />
            }
        ]
    }
];

const FAQSection = () => {
    const history = useHistory();
    const [expanded, setExpanded] = useState(false);

    const handleContact = () => {
        history.push('/p/kontakt');
    };

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div className={css.container}>
            <div className={css.contentWrapper}>
                <div className={css.leftColumn}>
                    <div className={css.headerArea}>
                        <h2 className={css.title}>
                            <FormattedMessage id="FAQSection.mainTitle" defaultMessage="Vanliga frågor" />
                        </h2>
                        <p className={css.subtitle}>
                            <FormattedMessage id="FAQSection.subTitle" defaultMessage="Hittar du inte svaret? Kontakta oss så hjälper vi dig." />
                        </p>
                    </div>

                    <div className={css.faqSections}>
                        {faqData.map((section, idx) => (
                            <div key={idx} className={css.faqCategory}>
                                <h3 className={css.categoryTitle}>{section.category}</h3>
                                <div className={css.accordionGroup}>
                                    {section.items.map((item, itemIdx) => {
                                        const panelId = `panel_${idx}_${itemIdx}`;
                                        const isOpen = expanded === panelId;
                                        const isLast = itemIdx === section.items.length - 1;
                                        return (
                                            <div
                                                key={itemIdx}
                                                className={css.accordion}
                                                style={{
                                                    borderTop: '1px solid var(--brandGrayLight)',
                                                    borderBottom: isLast ? '1px solid var(--brandGrayLight)' : 'none',
                                                }}
                                            >
                                                <button
                                                    type="button"
                                                    className={css.accordionSummary}
                                                    aria-expanded={isOpen}
                                                    onClick={() => setExpanded(isOpen ? false : panelId)}
                                                >
                                                    <span className={css.questionText}>{item.question}</span>
                                                    <ExpandMoreIcon
                                                        className={`${css.expandIcon}${isOpen ? ' ' + css.expandIconOpen : ''}`}
                                                    />
                                                </button>
                                                {isOpen ? (
                                                    <div className={css.accordionDetails}>
                                                        <span className={css.answerText}>{item.answer}</span>
                                                    </div>
                                                ) : null}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={css.rightColumn}>
                    <div className={css.contactCard}>
                        <h3 className={css.cardTitle}>
                            <FormattedMessage id="FAQSection.cardTitle" defaultMessage="Behöver du hjälp?" />
                        </h3>
                        <p className={css.cardSub}>
                            <FormattedMessage id="FAQSection.cardSub" defaultMessage="Vår oberoende kundsupport guidar dig till rätt hjul." />
                        </p>
                        <button className={css.primaryButton} onClick={handleContact}>
                            <EmailOutlinedIcon style={{ width: 18, height: 18 }} />
                            <FormattedMessage id="FAQSection.button.contactUs" defaultMessage="Kontakta oss" />
                        </button>
                        <button className={css.secondaryButton} onClick={() => history.push('/l/new')}>
                            <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46"></path></svg>
                            <FormattedMessage id="FAQSection.button.createRequest" defaultMessage="Skapa förfrågan" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQSection;
